// add to layout/theme.liquid before </head>
// as  <script src="{{ 'chat-customizations.js' | asset_url }}" defer></script>
(function () {
  let observer = null;

  function ensureElementRemainsHidden(el) {
    if (observer) return;
    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (el.style.display !== "none") {
          console.log(
            "[Customize Chat]: Element became visible - hiding again"
          );
          el.style.display = "none";
        }
      });
    });
    observer.observe(el, { attributes: true, attributeFilter: ["style"] });
  }

  function hideElement(el) {
    el.style.display = "none";
    ensureElementRemainsHidden(el);
  }

  function showElement(el) {
    if (observer) {
      observer.disconnect();
    }
    el.style.display = "block";
  }

  function shouldHideChat() {
    return !isContactPage();
  }

  function isContactPage() {
    return window.location.pathname === "/pages/contact";
  }

  function getChatElement() {
    return document.getElementById("shopify-chat");
  }

  function getChatElementPromise() {
    return new Promise((resolve, reject) => {
      const interval = 20;
      let attemptsLeft = 2000;

      const checkChatElement = () => {
        if (attemptsLeft === 0) {
          resolve(null);
          return;
        }

        attemptsLeft -= 1;
        const chatEl = getChatElement();
        if (chatEl) {
          resolve(chatEl);
        } else {
          setTimeout(checkChatElement, interval);
        }
      };

      checkChatElement();
    });
  }

  async function customizeChat() {
    const chatEl = await getChatElementPromise();
    if (!chatEl) {
      return;
    }

    if (shouldHideChat()) {
      hideElement(chatEl);
    } else {
      showElement(chatEl);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    customizeChat();
  });
})();

